module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('div', [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "name": "radio",
      "label": "业务板块",
      "rules": [{
        required: true,
        message: '请选择业务类型'
      }],
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-radio-group', {
          attrs: {
            "direction": "horizontal"
          },
          model: {
            value: (_vm.formData.type_name),
            callback: function($$v) {
              _vm.$set(_vm.formData, "type_name", $$v)
            },
            expression: "formData.type_name"
          }
        }, [_c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "竞赛"
          }
        }, [_vm._v("竞赛")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "培训"
          }
        }, [_vm._v("培训")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "星级俱乐部"
          }
        }, [_vm._v("星级俱乐部")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "七彩星级"
          }
        }, [_vm._v("七彩星级")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "其他"
          }
        }, [_vm._v("其他")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.formData.type_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "type_name", $$v)
      },
      expression: "formData.type_name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "radio",
      "label": "是否匿名",
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-radio-group', {
          attrs: {
            "direction": "horizontal"
          },
          model: {
            value: (_vm.formData.niming),
            callback: function($$v) {
              _vm.$set(_vm.formData, "niming", $$v)
            },
            expression: "formData.niming"
          }
        }, [_c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": 1
          }
        }, [_vm._v("匿名")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": 2
          }
        }, [_vm._v("实名")])], 1)]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rows": "2",
      "autosize": "",
      "rules": [{
        required: true,
        message: '请输入意见或建议'
      }],
      "type": "textarea",
      "maxlength": "500",
      "placeholder": "请输入您的意见或建议...",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.formData.content),
      callback: function($$v) {
        _vm.$set(_vm.formData, "content", $$v)
      },
      expression: "formData.content"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n            提交申请\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  }), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "信箱@CCA",
      "confirm-button-text": "信箱入口",
      "show-cancel-button": true,
      "cancel-button-text": "取消"
    },
    on: {
      "confirm": function($event) {
        _vm.showNotice = false
      },
      "cancel": function($event) {
        return _vm.back()
      }
    },
    model: {
      value: (_vm.showNotice),
      callback: function($$v) {
        _vm.showNotice = $$v
      },
      expression: "showNotice"
    }
  }, [_c('div', {
    staticClass: "notice_content"
  }, [_c('p', [_vm._v("欢迎您@CCA。您对啦啦操竞赛、培训、星级俱乐部、七彩星级有什么感受？您对啦啦操项目推广及未来发展有何高招与高见？啦啦操离不开大家的真知灼见。")]), _vm._v(" "), _c('p', [_vm._v("您的留言将被转给有关业务部门和地方，并可能以不同形式公开。")]), _vm._v(" "), _c('p', [_vm._v("汲取各方智慧，倾听阁下意见，采纳诸君建议。您对啦啦操的期望，也是我们努力的方向。")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2956c196","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/Gbook.vue
// module id = 2290
// module chunks = 0